export const IMAGES = {
  downArrow: require("../_uLearn/assets/media/svg_uLearn/down-arrow.svg"),
};
export const appTypeJSON = [
  {
    label: "Teacher App",
    title: "Teacher App",
    value: "i3",
  },
  {
    label: "Parent App",
    title: "Parent App",
    value: "i4",
  },
];
